import { FilterDTO, SortDirection } from "../../models/models.swagger.generated";

export class PagedQueryModel {
    static getDefault(): PagedQueryModel {
        return new PagedQueryModel();
    }

    public skip: number = 0;
    public take: number = 15;
    public sortBy: string = '';
    public sortDirection: SortDirection = SortDirection.Ascending;
    public pageSize: number = 15;
    public search: string = '';
    public filters: FilterDTO[] = [];

    public getPageSizes(): number[] {
        return [15, 30, 50, 100];
    }
}